<template>
  <v-container fluid>
    <v-layout justify-center align-start v-if="!data._id" class="printNone">
      <v-flex xl2 md4 sm6 xs12>
        <v-card class="br-10 pa-4 text-center">
          <div class="title pa-3">{{ $t('searching') }}</div>
          <v-layout row wrap pt-2 justify-center class="pa-5">
            <v-btn :block="$vuetify.breakpoint.xsOnly" color="primary" class="white--text" rounded type="button" large @click="$router.push('/'); resetData()">{{ $t('go_to_homepage') }}</v-btn>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
    <v-list two-line class="br-10" dense v-if="data._id">
      <v-subheader><h3>{{ $t('complaint_info') }}</h3></v-subheader>
      <v-divider></v-divider>
      <v-list-item>
        <v-list-item-action>
          <v-icon color="primary lighten-2" class="pl-2">fa-bookmark fa-lg</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title class="body-2">{{ data._id }}</v-list-item-title>
          <v-list-item-subtitle class="body-2">{{ $t('complaint_no') }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-action>
          <v-icon color="primary lighten-2" class="pl-2">fa-calendar fa-lg</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title class="body-2">{{ data.date | dateTime }}</v-list-item-title>
          <v-list-item-subtitle class="body-2">{{ $t('date') }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-action>
          <v-icon color="primary lighten-2" class="pl-2">fa-list-ul fa-lg</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title class="body-2">{{ $t(data.category) }}</v-list-item-title>
          <v-list-item-subtitle class="body-2">{{ $t('category') }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-action>
          <v-icon color="primary lighten-2" class="pl-2">fa-stack-exchange fa-lg</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title class="body-2">{{ data.description | capitalize }}</v-list-item-title>
          <v-list-item-subtitle class="body-2">{{ $t('description') }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-action>
          <v-icon color="primary lighten-2" class="pl-2">fa-info-circle fa-lg</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title class="body-2">{{ $t(data.status) }}</v-list-item-title>
          <v-list-item-subtitle class="body-2">{{ $t('status') }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-action>
          <v-icon color="primary lighten-2" class="pl-2">fa-map-pin fa-lg</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title class="body-2">{{ data.location | capitalize }}</v-list-item-title>
          <v-list-item-subtitle class="body-2">{{ $t('location') }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-action>
          <v-icon color="primary lighten-2" class="pl-2">fa-headphones fa-lg</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title class="body-2">{{ data.channel | capitalize }}</v-list-item-title>
          <v-list-item-subtitle class="body-2">{{ $t('channel') }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <br>
    <v-list two-line class="br-10" dense v-if="data._id">
      <v-subheader><h3>{{ $t('complainant_info') }}</h3></v-subheader>
      <v-divider></v-divider>
      <v-list-item>
        <v-list-item-action>
          <v-icon color="primary lighten-2" class="pl-2">fa-user-circle fa-lg</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title class="body-2">{{ data.complainant.full_name }}</v-list-item-title>
          <v-list-item-subtitle class="body-2">{{ $t('name', { field: '' }) }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-action>
          <v-icon color="primary lighten-2" class="pl-2">fa-id-card fa-lg</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title class="body-2">{{ data.complainant.ic_num }}</v-list-item-title>
          <v-list-item-subtitle class="body-2">{{ $t('ic_num') }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-action>
          <v-icon color="primary lighten-2" class="pl-2">fa-phone fa-lg</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title class="body-2">{{ data.complainant.phone }}</v-list-item-title>
          <v-list-item-subtitle class="body-2">{{ $t('phone', { field: '' }) }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-action>
          <v-icon color="primary lighten-2" class="pl-2">fa-at fa-lg</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title class="body-2">{{ data.complainant.email }}</v-list-item-title>
          <v-list-item-subtitle class="body-2">{{ $t('email', { field: '' }) }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <br>
    <v-card class="elevation-0 br-10" :key="name" v-for="(attachment, name) in data._attachments">
      <v-list two-line class="br-10 text-center" dense>
        <v-subheader><h3>{{ $t('attachment') }}</h3></v-subheader>
        <v-divider></v-divider>
        <v-list-item>
          <v-img contain :src="`${data.attachmentUrl}/${data._id}/${name}`" max-height="300px" max-width="300px" v-if="attachment.content_type.split('/')[0] === 'image'"/>
          <v-list-item-action>
            <v-icon>fa-paperclip fa-lg</v-icon>
          </v-list-item-action>
          <v-list-item-content class="text-left">
            <v-list-item-title class="font-weight-medium">{{ name }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-card>
  </v-container>
</template>

<script>
import vuex from 'vuex'

export default {
  beforeMount () {
    this.fetchData({ id: this.$route.params.id })
  },
  computed: {
    ...vuex.mapState({
      data: state => state.complaint.data
    })
  },
  methods: {
    ...vuex.mapActions({
      fetchData: 'complaint/fetchData'
    })
  }
}
</script>
